/**
 * Userを管理するStateを扱うモジュール
 */
import { ActionsUnion, createAction } from 'common/utils/action-utils';

enum ActionTypes {
  BEGIN_LOGOUT = 'app/user/BEGIN_LOGOUT'
}

export enum LogoutStatus {
  // 処理中
  PROCESSING,
  // 未処理
  UNTREATED
}

/**
 * ログアウト開始のActionを作成する
 */
export const beginLogout = () => createAction(ActionTypes.BEGIN_LOGOUT);

const actions = {
  beginLogout
};

type userAction = ActionsUnion<typeof actions>;

/** UserのState */
export interface UserState {
  logoutStatus: LogoutStatus | string;
}

const initialState: UserState = {
  logoutStatus: LogoutStatus.UNTREATED
};

export default (
  state: UserState = initialState,
  actions: userAction
): UserState => {
  switch (actions.type) {
    case ActionTypes.BEGIN_LOGOUT:
      return {
        ...state,
        logoutStatus: LogoutStatus.PROCESSING
      };
    default:
      return state;
  }
};
